import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
} from '@mui/material';

const BroadcastConfirmDialog = ({ open, recipientCount, onCancel, onConfirm, sending }) => {
  return (
    <Dialog
      open={open}
      onClose={sending ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      aria-labelledby="broadcast-confirm-title"
      aria-describedby="broadcast-confirm-description"
    >
      <DialogTitle id="broadcast-confirm-title">
        Send to {(recipientCount || 0).toLocaleString()} users?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="broadcast-confirm-description">
          This cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={sending} autoFocus>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          disabled={sending}
          startIcon={sending ? <CircularProgress size={18} color="inherit" /> : null}
        >
          {sending ? 'Sending...' : 'Send'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BroadcastConfirmDialog;
